import styled from 'styled-components';
import Image from '@stencil/image';
import TickIcon from '../../../../../../stories/Icons/TickIcon';

export const GoSafeDropDownOuter = styled.div(
  props => `
    position:absolute;
    z-index:${props.theme.misc.zIndex.base};
    bottom: ${props.positionTop && '100%'};
    top: ${!props.positionTop && '100%'};
    padding-bottom: ${props.positionTop && '1rem'};
    padding-top: ${!props.positionTop && '1rem'};
    left: 10%;
  `,
);

export const GoSafeTagContainer = styled.div(
  props => `
    position:relative;
    width: fit-content;
    cursor:pointer;
  `,
);

export const GoSafeDropDownHover = styled.div(
  props => `
    width:39.4rem;
    border:.1rem solid ${props.theme.colors.goGreen.light};
    border-radius: ${props.theme.misc.borderRadius.large};
    padding:${props.theme.spacing.large} ${props.theme.spacing.xlarge};
    background: ${props.backgroundColor || props.theme.colors.goGreen.light};
    z-index:${props.theme.misc.zIndex.base};
  `,
);

export const GosafeImg = styled(Image)(
  props => `
  width: ${props.width || '5rem'};
  height: ${props.height || 'auto'};
  object-fit: contain;
  margin-left: ${props.theme.spacing.base};
    `,
);

export const TickIconWrap = styled(TickIcon)(
  props => `

    width:1rem;
    height:1rem;
    fill: ${props.theme.colors.goGreen.dark};
  `,
);

export const TipUI = styled.div`
  position: absolute;
  width: 2.4rem;
  height: 2.4rem;
  overflow: hidden;
  &::after {
    content: '';
    position: absolute;
    width: 1.3rem;
    height: 1.2rem;
    left: 50%;
    background: ${props => props.theme.colors.goGreen.light};
    z-index: ${props => props.theme.misc.zIndex.large};
  }
`;

export const TipPositioning = styled(TipUI)`
  left: ${props => props.theme.spacing.custom(15)}
  top: ${props => !props.positionTop && '-0.1rem'};
  bottom: ${props => props.positionTop && '-0.1rem'};
  &::after {
    transform: translate(-50%, 50%) rotate(45deg);
    background: ${props => props.bgColor};
    border-top: 0.1rem solid ${props =>
      (!props.positionTop && props.theme.colors.goGreen.light) || 'transparent'};
    border-left: 0.1rem solid ${props =>
      (!props.positionTop && props.theme.colors.goGreen.light) || 'transparent'};
    border-bottom: 0.1rem solid ${props =>
      (props.positionTop && props.theme.colors.goGreen.light) || 'transparent'};
    border-right: 0.1rem solid ${props =>
      (props.positionTop && props.theme.colors.goGreen.light) || 'transparent'};
  }
`;

export const GoSafeDropDownItem = styled.li(
  props => `
    display:flex;
    align-items: center;
    padding-bottom:${props.theme.spacing.small};
  `,
);

export const GoSafeDropDownItemText = styled.p(
  props => `
    font-size:${props.theme.font.custom(14)};
    color: ${props.textColor || props.theme.colors.downriver.dark};
    padding-left:${props.theme.spacing.small};
  `,
);
